module.exports = __webpack_public_path__ + "static/girl-looking-left-stretched-1e6d9617fb92292d85913f698faec684.jpg";